// src/styles/GlobalStyles.tsx
import * as React from "react";
import { GlobalStyles, useTheme } from "@mui/material";

const GlobalBaseStylesComponent: React.FC = () => {
  const theme = useTheme();
  const isLight = theme.palette.mode === "light";

  // 스타일 객체를 useMemo로 메모이제이션하여 불필요한 리렌더링 방지
  const styles = React.useMemo(
    () => ({
      "html, body, #root": {
        height: "100%",
        backgroundColor: theme.palette.background.default,
        color: theme.palette.text.primary,
      },
      "*": { boxSizing: "border-box" },
      "::selection": {
        background: theme.palette.primary.main,
        color: isLight ? "#ffffff" : "#0D0F13",
      },
      /* Scrollbars */
      "::-webkit-scrollbar": { width: 10, height: 10 },
      "::-webkit-scrollbar-track": {
        background: isLight ? "#EDF1F7" : "#0E1116",
      },
      "::-webkit-scrollbar-thumb": {
        background: isLight ? "rgba(0,0,0,0.22)" : "rgba(255,255,255,0.22)",
        borderRadius: 8,
        border: isLight ? "2px solid #EDF1F7" : "2px solid #0E1116",
      },
      a: {
        color: theme.palette.primary.main,
        textDecoration: "none",
      },
      "a:hover": {
        textDecoration: "underline",
      },
      /* Default hover transition for interactive elements */
      'button, [role="button"], .MuiButtonBase-root': {
        transition:
          "background-color .2s ease, color .2s ease, border-color .2s ease, box-shadow .2s ease",
      },
    }),
    [
      theme.palette.background.default,
      theme.palette.text.primary,
      theme.palette.primary.main,
      isLight,
    ]
  );

  return <GlobalStyles styles={styles} />;
};

// React.memo로 메모이제이션하여 theme이 변경될 때만 리렌더링
export default React.memo(GlobalBaseStylesComponent);
